// extracted by mini-css-extract-plugin
export var splash = "Splash-module--splash--4de76";
export var splashInner = "Splash-module--splashInner--e92a4";